import React, { useState } from "react";
import MatchesSidebar from "./MatchesSidebar";
import { Outlet } from "react-router-dom";
import { FaBars } from "react-icons/fa";

const MatchesLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="relative w-full  bg-gray-50 overflow-hidden">
      {/* Mobile Sidebar */}
      {sidebarOpen && (
        <div className="fixed inset-0 z-50 flex">
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-black/30 backdrop-blur-sm transition-all"
            onClick={() => setSidebarOpen(false)}
          />
          {/* Slide-in Sidebar */}
          <div className="relative z-50 w-64 bg-white shadow-lg h-full animate-slideIn overflow-y-auto">
            <MatchesSidebar onClose={() => setSidebarOpen(false)} />
          </div>
        </div>
      )}

      {/* Desktop Sidebar */}
      <div className="hidden md:block fixed top-0 left-0 h-full w-64 bg-white shadow-lg overflow-y-auto border-r">
        <MatchesSidebar />
      </div>

      {/* Mobile Top Bar */}
      <div className="md:hidden flex items-center justify-between px-4 py-3 bg-white shadow sticky top-0 z-40">
        <button
          onClick={() => setSidebarOpen(true)}
          className="text-pink-600 p-2 rounded hover:bg-pink-50"
        >
          <FaBars size={20} />
        </button>
        <h2 className="text-lg font text-pink-600">JAIN VAR VADHU</h2>
        <div /> {/* Spacer */}
      </div>

      {/* Main Content */}
      <div className="md:ml-64 h-full overflow-y-auto match-card-mobile bg-white ">
        <div className="px-3 pt-4 md:px-6 md:pt-6 lg:px-8 lg:pt-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MatchesLayout;
